module.exports = __webpack_public_path__ + "media/images/countrysquared/je-8e30627c315bffb28d7f487e7cfba897.svg";